import { render, staticRenderFns } from "./policyStatusDialog.vue?vue&type=template&id=da2e72e4&scoped=true&"
import script from "./policyStatusDialog.vue?vue&type=script&lang=js&"
export * from "./policyStatusDialog.vue?vue&type=script&lang=js&"
import style0 from "./policyStatusDialog.vue?vue&type=style&index=0&id=da2e72e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2e72e4",
  null
  
)

export default component.exports